//@ts-check

class API {
    static _form(form) {
        let frm = new FormData();

        for (let key in form) {
            if (!form.hasOwnProperty(key)) continue;

            if (form[key] === undefined) continue;
            if (typeof form[key] === 'object') {
                for (let col in form[key]) {
                    if (!form[key].hasOwnProperty(col)) continue;

                    frm.set(`${key}[${col}]`, form[key][col]);
                }

                continue;
            }

            frm.set(key, form[key]);
        }

        return frm;
    }

    static _get(path) {
        return fetch(path, {
            credentials: 'same-origin'
        }).then(res => {
            return res.json();
        });
    }

    static _post(path, body) {
        return fetch(path, {
            body: this._form(body),
            method: 'POST',
            credentials: 'same-origin'
        }).then(res => {
            if (!res.ok) throw new Error('Generic failure');

            return res.json();
        }).catch(e => {
            return false;
        });
    }

    static getRecordings() {
        return fetch(`/api/recordings`, {
            credentials: 'same-origin',
            method: 'GET'
        }).then(res => {
            if (!res.ok) throw new Error('Item not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    }

    static preparePayment(type, id, code) {
        return fetch(`/api/${type}/${id}/${code}/payment`, {
            credentials: 'same-origin',
            method: 'GET'
        }).then(res => {
            if (!res.ok) throw new Error('Item not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    }

    static getCompany(ico) {
        return fetch(`/api/ico-lookup?ico=${ico}`, {
            credentials: 'same-origin',
            method: 'GET'
        }).then(res => {
            if (!res.ok) throw new Error('Item not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    }

    static getInvoice(type, id, code) {
        return fetch(`/api/invoice/${type}/${id}/${code}`, {
            credentials: 'same-origin',
            method: 'GET'
        }).then(res => {
            if (!res.ok) throw new Error('Item not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    }

    static setInvoice(type, id, code, invoice) {
        let form = new FormData();
        for (let prop in invoice) invoice.hasOwnProperty(prop) && form.set(`invoice[${prop}]`, invoice[prop]);

        return fetch(`/api/invoice/${type}/${id}/${code}`, {
            credentials: 'same-origin',
            method: 'POST',
            body: form
        }).then(res => {
            if (!res.ok) throw new Error('Item not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    }

    static streamSubscribe(evrId, clnId, code) {
        return this._post('/api/stream/subscribe', {
            evrId, clnId, code
        });
    }

    static streamCheck(token) {
        return this._post('/api/stream/check', {
            token
        });
    }

    static streamRate(token, type, value) {
        return this._post('/api/stream/rate', {
            token, type, value
        });
    }

    static goToStream(evrId, code) {
        return this._post('/api/events/go-to-stream', {
            evrId, code
        });
    }

    static recordingSubscribe(recId, clnId, code) {
        return this._post('/api/recording/subscribe', {
            recId, clnId, code
        });
    }

    static recordingCheck(token) {
        return this._post('/api/recording/check', {
            token
        });
    }
}

export default API;